import React from 'react';
import { Checkbox, Input } from 'antd';
import { helper } from 'utils';

const MultiChecks = ({ max, used, value, options, disabled, onChange }) => {
	const [q, setQ] = React.useState('');
	const [uzed, setUzed] = React.useState(used || []);

	const dizabled = disabled || (max && max === value.length);
	const aptions = options.sort((a, b) => helper.sortString(a, b, 'label'));
	const filteredOptions = q
		? aptions.filter((item) =>
				item.label.toLowerCase().includes(q.toLowerCase())
			)
		: aptions;

	const addItem = (item) => {
		const copyValue = helper.copyObject(value);
		setUzed((su) => (su || []).concat(item.value));
		onChange(copyValue.concat(item.value));
	};

	const delItem = (item) => {
		const copyValue = helper.copyObject(value);
		setUzed((su) => (su || []).filter((e) => e !== item.value));
		onChange(copyValue.filter((e) => e !== item.value));
	};

	return (
		<React.Fragment>
			<div id="MultiChecks">
				<div className="bg-light rounded p-4">
					<Input
						size="large"
						placeholder="Search..."
						onChange={(e) => setQ(e.target.value)}
					/>
					<div className="row">
						<div className="col-5">
							<div className="mt-3" style={{ height: 500, overflow: 'scroll' }}>
								{aptions
									.filter((item) => value.includes(item.value))
									.map((item, i) => (
										<div
											key={`${i}_item_${i}`}
											className="mb-2 text-truncate d-flex justify-content align-items-center"
										>
											<div
												className="px-1 rounded bg-red pointer primary"
												onClick={() => delItem(item)}
											>
												<b>x</b>
											</div>
											<div className="ml-2">{item.label}</div>
										</div>
									))}
							</div>
						</div>
						<div className="col-7">
							<div
								className="mt-3 border rounded p-3"
								style={{ height: 500, overflow: 'scroll' }}
							>
								{filteredOptions
									.filter((item) => !uzed.includes(item.value))
									.map((item, i) => (
										<div key={`${i}_${item.value}`} className="mb-1">
											<Checkbox
												value={item.value}
												checked={value.includes(item.value)}
												disabled={dizabled}
												onChange={(e) => {
													if (e.target.checked) {
														addItem(item);
													} else {
														delItem(item);
													}
												}}
											>
												{item.label}
											</Checkbox>
										</div>
									))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default MultiChecks;
